import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleContextConsumer, CollapsibleHeading } from '$partials/base/collapsible.jsx';
import IconChevron from '$partials/icons/icon-chevron';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TextAccordion}
 */

const TextAccordion = ({
    heading,
    col1Heading,
    col2Heading,
    col1Items,
    col2Items
}) => {

    const renderItemText = (item) => {
        if (typeof item?.text === 'string') {
            return <div dangerouslySetInnerHTML={{ __html: item.text }} />;
        }

        if (item?.slug && item?.name) {
            return (
                <p>
                    <a
                        href={`/${item.slug}`}>
                        {item.name}
                    </a>
                </p>
            );
        }
        return null;
    };

    return (
        <div className='module-highlights-amenities-block'>
            <div className='module-product-detail-section bg-main-blackground'>
                <div className='layout-container layout-site-outer-padding py-16 sm:py-40 md:py-48'>
                    <div className='flex gap-y-32 flex-col md:flex-row col-wrapper'>
                        <div className='md:w-4/12 col-padding'>
                            {heading && (
                                <h2 className='type-style-2'>{heading}</h2>
                            )}
                        </div>
                        <div className='pt-10 flex flex-col gap-y-48 sm:gap-42 md:gap-48 sm:flex-row col-padding md:w-8/12'>
                            {/* Column 1 */}
                            {col1Items?.length > 0 && (
                                <>
                                    <div className='sm:w-1/2'>
                                        {col1Heading && (
                                            <h3 className='type-style-3 mb-24'>{col1Heading}</h3>
                                        )}
                                        {col1Items && (
                                            <ul>
                                                {col1Items.slice(0, 5).map((item, index) => (
                                                    <li
                                                        className='border-t border-main-border py-12 sm:py-16 type-style-body-r'
                                                        key={`col2-item-${index}`}>
                                                        {renderItemText(item)}
                                                    </li>
                                                ))}

                                                {col1Items.length > 5 && (
                                                    <Collapsible
                                                        className='w-full'
                                                        id={'col1-more'}
                                                        isOpened={false}
                                                        key={'col1-more'}>
                                                        <CollapsibleContent>
                                                            {col1Items.slice(5).map((item, i) => (
                                                                <li
                                                                    className='border-t border-main-border py-12 sm:py-16 type-style-body-r'
                                                                    key={`col1-item-${i + 5}`}>
                                                                    {renderItemText(item)}
                                                                </li>
                                                            ))}
                                                        </CollapsibleContent>
                                                        <CollapsibleHeading className='cursor-pointer border-t border-main-border py-12 sm:py-16 w-full'>
                                                            <CollapsibleContextConsumer>
                                                                {({ isOpened }) => (
                                                                    <span className='type-style-eyebrow flex items-center gap-x-[5.5px]'>
                                                                        {isOpened ? 'Show less' : `View ${col1Items.length - 5} more`}
                                                                        <IconChevron className={isOpened ? '-rotate-180' : ''}/>
                                                                    </span>
                                                                )}
                                                            </CollapsibleContextConsumer>
                                                        </CollapsibleHeading>
                                                    </Collapsible>
                                                )}
                                            </ul>
                                        )}
                                    </div>
                                </>
                            )}
                            {/* Column 2 */}
                            {col2Items?.length > 0 && (
                                <>
                                    <div className='sm:w-1/2'>
                                        {col2Heading && (
                                            <h3 className='type-style-3 mb-24'>{col2Heading}</h3>
                                        )}
                                        {col2Items && (
                                            <ul>
                                                {col2Items.slice(0, 5).map((item, index) => (
                                                    <li
                                                        className='border-t border-main-border py-12 sm:py-16 type-style-body-r'
                                                        key={`col2-item-${index}`}>
                                                        {renderItemText(item)}
                                                    </li>
                                                ))}

                                                {col2Items.length > 5 && (
                                                    <Collapsible
                                                        className='w-full'
                                                        id={'col1-more'}
                                                        isOpened={false}
                                                        key={'col1-more'}>
                                                        <CollapsibleContent>
                                                            {col2Items.slice(5).map((item, i) => (
                                                                <li
                                                                    className='border-t border-main-border py-12 sm:py-16 type-style-body-r'
                                                                    key={`col2-item-${i + 5}`}>
                                                                    {renderItemText(item)}
                                                                </li>
                                                            ))}
                                                        </CollapsibleContent>
                                                        <CollapsibleHeading className='cursor-pointer border-t border-main-border py-12 sm:py-16 w-full'>
                                                            <CollapsibleContextConsumer>
                                                                {({ isOpened }) => (
                                                                    <span className='type-style-eyebrow flex items-center gap-x-[5.5px]'>
                                                                        {isOpened ? 'Show less' : `View ${col2Items.length - 5} more`}
                                                                        <IconChevron className={isOpened ? '-rotate-180' : ''}/>
                                                                    </span>
                                                                )}
                                                            </CollapsibleContextConsumer>
                                                        </CollapsibleHeading>
                                                    </Collapsible>
                                                )}
                                            </ul>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TextAccordion;
